// import React, { Fragment, useState } from "react";
// import {
//   Box,
//   CardMedia,
//   Container,
//   Typography,
//   Grid,

//   IconButton,
//   TextField,
// } from "@mui/material";
// import { makeStyles } from "@mui/styles";
// import moment from "moment";
// import {
//   EmailOutlined,
//   FacebookOutlined,
//   Instagram,

//   LinkedIn,
//   LocationOnOutlined,
//   WhatsApp,
//   X,
//   YouTube,
// } from "@mui/icons-material";
// import { Link } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import styled from "@emotion/styled";
// import Colors from "assets/Style/Colors";
// import { FontFamily, Images } from "assets";
// import { ErrorToaster } from "components/Toaster";
// import { AccessTime } from "@mui/icons-material";
// const useStyles = makeStyles({
//   mailBox: {
//     position: "absolute",
//     top: "50%",
//     right: "-35px",
//     transform: "translateY(-50%) skewX(-17deg)",
//     height: "58px",
//     width: "60px",
//     fontSize: "24px",
//     color: Colors.white,
//     borderRadius: "4px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     textAlign: "center",
//     backgroundColor: Colors.primary,
//   },
//   list: {
//     display: "flex",
//     alignItems: "center",
//     gap: "4px",
//     cursor: "pointer",
//     transition: "0.3s ease-in-out",
//     "&:hover .MuiSvgIcon-root, &:hover .MuiTypography-root": {
//       color: Colors.primary,
//       transition: "0.3s ease-in-out",
//     },
//   },
//   copyRight: {
//     fontFamily: `${FontFamily.NunitoRegular} !important`,
//     color: Colors.primary,
//     cursor: "pointer",
//     transition: "0.3s ease-in-out",
//     "&:hover": {
//       color: Colors.white,
//     },
//   },
// });

// const CustomTextField = styled(TextField)({
//   "& .MuiOutlinedInput-root": {
//     "& fieldset": {
//       borderColor: Colors.white + "2b", // Change the border color here
//     },
//     "&:hover fieldset": {
//       borderColor: Colors.white + "2b", // Change the border color on hover here
//     },
//     "&.Mui-focused fieldset": {
//       borderColor: Colors.primary, // Change the border color when focused here
//     },
//     "& input": {
//       color: Colors.white, // Change the text color here
//       fontSize: "13px",
//       fontWeight: 300,
//       fontFamily: FontFamily.NunitoRegular,
//     },
//   },
// });

// function Footer() {
//   const classes = useStyles();
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm();
//   const [loading, setLoading] = useState(false);

//   const iconBtn = {
//     backgroundColor: "#313c44",
//     width: "40px",
//     height: "40px",
//     transition: "0.3s ease-in-out",
//   };

//   const quickLinks = [
//     { title: "Home", path: "/" },
//     { title: "Services", path: "/services" },
//     { title: "About Us", path: "/about" },
//     { title: "Blogs", path: "/blogs" },
//     { title: "Quote", path: "/quote" },
//     { title: "Careers", path: "/careers" },
//     { title: "Contact Us", path: "/contact" },
//     { title: "Buy A Car", path: "/buycar" },
//   ];

//   // *For NewsLetter
//   const newsLetter = async (formData) => {
//     setLoading(true);
//     try {
//       console.log(formData);
//     } catch (error) {
//       ErrorToaster(error);
//     } finally {
//       setTimeout(() => {
//         setLoading(false);
//       }, 2000);
//     }
//   };

//   return (
//     <Fragment>
//       {/* ========== Footer TopBar ========== */}
//       {/* <TopBar /> */}

//       {/* ========== Footer ========== */}
//       <CardMedia
       
//         sx={{
//           bgcolor: Colors.footerBg,
//           pt: "40px",
//           borderBottom: `1px solid ${Colors.white + "1f"}`,
//         }}
//       >
//        <Container maxWidth="xl">
//   <Grid container spacing={{ xs: 3, md: 4 }} >
//             <Grid item xs={12} sm={6} md={4}>
//               <Link to="/">
//                 <Box
//                   component="img"
//                   src={Images.GalaxyLogo}
//                   alt="Galaxy World Wide Shipping"
//                   sx={{ height: { xs: "60px", lg: "90px" } }}
//                 />
//               </Link>
//               <Box sx={{ mb: 4, mt: 2.5 }}>
//                 <Typography
//                   variant="body1"
//                   sx={{
//                     fontFamily: FontFamily.NunitoRegular,
//                     color: Colors.white,
//                   }}
//                 >
//                   Galaxy Worldwide Shipping company is one of the top Auto
//                   Shipping Firms in UAE and the world since 2005. Galaxy
//                   provides fast, reliable, and high-quality shipping services.
//                   We can import or export your brand new, used or custom made
//                   cars, boats, bikes, and trucks from and to UAE and the world.
//                 </Typography>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     gap: "10px",
//                     alignItems: "center",
//                     mt: 3,
//                     mb: 2,
//                   }}
//                 >
//                   <Typography
//                     component={"a"}
//                     href={"https://wa.me/+97165102000"}
//                     target={"_blank"}
//                   >
//                     <IconButton
//                       sx={{
//                         ...iconBtn,
//                         "&:hover": { bgcolor: Colors.whatsapp },
//                       }}
//                     >
//                       <WhatsApp
//                         sx={{ fontSize: "18px", color: Colors.white }}
//                       />
//                     </IconButton>
//                   </Typography>
//                   <Typography
//                     component={"a"}
//                     href={"https://www.facebook.com/GalaxyWorldWideShipping"}
//                     target={"_blank"}
//                   >
//                     <IconButton
//                       sx={{
//                         ...iconBtn,
//                         "&:hover": { bgcolor: Colors.facebook },
//                       }}
//                     >
//                       <FacebookOutlined
//                         sx={{ fontSize: "18px", color: Colors.white }}
//                       />
//                     </IconButton>
//                   </Typography>
//                   <Typography
//                     component={"a"}
//                     href={
//                       "https://www.instagram.com/GalaxyWorldWideshippingllc"
//                     }
//                     target={"_blank"}
//                   >
//                     <IconButton
//                       sx={{
//                         ...iconBtn,
//                         "&:hover": { bgcolor: Colors.instagram },
//                       }}
//                     >
//                       <Instagram
//                         sx={{ fontSize: "18px", color: Colors.white }}
//                       />
//                     </IconButton>
//                   </Typography>
//                   <Typography
//                     component={"a"}
//                     href={
//                       "https://www.linkedin.com/company/galaxyworldwideshipping"
//                     }
//                     target={"_blank"}
//                   >
//                     <IconButton
//                       sx={{
//                         ...iconBtn,
//                         "&:hover": { bgcolor: Colors.linkedin },
//                       }}
//                     >
//                       <LinkedIn
//                         sx={{ fontSize: "18px", color: Colors.white }}
//                       />
//                     </IconButton>
//                   </Typography>
//                   <Typography
//                     component={"a"}
//                     href={"https://twitter.com/GWWS_LLC"}
//                     target={"_blank"}
//                   >
//                     <IconButton
//                       sx={{ ...iconBtn, "&:hover": { bgcolor: Colors.black } }}
//                     >
//                       <X sx={{ fontSize: "18px", color: Colors.white }} />
//                     </IconButton>
//                   </Typography>
//                   <Typography
//                     component={"a"}
//                     href={
//                       "https://www.youtube.com/channel/UC_8dvAz4l3v1jSRQdoU8wAA"
//                     }
//                     target={"_blank"}
//                   >
//                     <IconButton
//                       sx={{
//                         ...iconBtn,
//                         "&:hover": { bgcolor: Colors.youtube },
//                       }}
//                     >
//                       <YouTube sx={{ fontSize: "18px", color: Colors.white }} />
//                     </IconButton>
//                   </Typography>
//                 </Box>
//               </Box>
//             </Grid>
//             {/* <Grid item xs={12} sm={6} md={2}>
//               <Box
//                 sx={{ pl: { lg: "30px", md: "0", sm: "0", xs: "0" }, mt: 3 }}
//               >
//                 <Typography variant="h5" sx={{ color: Colors.white }}>
//                   Quick Links
//                 </Typography>
//                 <Box className={"heading-divider"} sx={{ mt: 2.5, mb: 3 }} />
//                 <Box component={"ul"} sx={{ p: 0 }}>
//                   {quickLinks.map((item, index) => (
//                     <Box
//                       key={index}
//                       component={"li"}
//                       sx={{ listStyle: "none", pb: 3 }}
//                     >
//                       <Box
//                         component={Link}
//                         to={item.path}
//                         className={classes.list}
//                       >
//                         <KeyboardDoubleArrowRight sx={{ color: Colors.grey }} />
//                         <Typography
//                           variant="body1"
//                           sx={{
//                             color: Colors.grey,
//                             fontFamily: FontFamily.NunitoRegular,
//                           }}
//                         >
//                           {item.title}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   ))}
//                 </Box>
//               </Box>
//             </Grid> */}
//             <Grid item xs={12} sm={6} md={2}>
//               <Box sx={{ pl: { lg: "30px", md: "0", sm: "0", xs: "0" }, mt: 3 }}>
//                 <Typography variant="h5" sx={{ color: Colors.white }}>
//                   Quick Links
//                 </Typography>

//                 {/* Quick Links in three columns on mobile view */}
//                 <Box component={"ul"} sx={{ p: 0 , display: "flex", alignItems: "start", justifyContent:"flex-start", flexDirection:"column" }}>
//                   {quickLinks.map((item, index) => (
//                     <Box
//                       key={index}
//                       component={"li"}
//                       sx={{
//                         listStyle: "none",
//                         pb: 3,
//                         width: { xs: "33.33%", sm: "100%" }, // 3 columns on mobile, 1 column on larger screens
//                         paddingRight: { xs: "15px", sm: "0" }, // Add right padding for small screens
//                       }}
//                     >
//                       <Box component={Link} to={item.path} className={classes.list}>
                        
//                         <Typography
//                           variant="body1"
//                           sx={{
//                             color: Colors.white,
//                             textAlign: "start",
//                             fontFamily: FontFamily.NunitoRegular,
//                           }}
//                         >
//                           {item.title}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   ))}
//                 </Box>
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ mt: 3 }}>
//                 <Typography variant="h5" sx={{ color: Colors.white }}>
//                   Find Us
//                 </Typography>
               
//                 <Box sx={{ mb: 4 , gap:6 }}>
//                   <Box sx={{ display: "flex", alignItems: "center" }}>
//                     <EmailOutlined
//                       sx={{ fontSize: "28px", mr: 1.5, color: Colors.primary }}
//                     />
//                     <Typography
//                       component={"a"}
//                       href={"mailto:info@galaxyshipping.com"}
//                       variant="body1"
//                       sx={{
//                         fontFamily: FontFamily.NunitoRegular,
//                         color: Colors.grey,
//                         transition: "0.3s ease-in-out",
//                         "&:hover": { color: Colors.primary },
//                       }}
//                     >
//                       info@galaxyshipping.com
//                     </Typography>
//                   </Box>
                
//                   <Box sx={{ display: "flex", alignItems: "center" }}>
//                     <WhatsApp
//                       sx={{ fontSize: "28px", mr: 1.5, color: Colors.primary }}
//                     />
//                     <Typography
//                       component={"a"}
//                       href={"https://wa.me/+97165102000"}
//                       target={"_blank"}
//                       variant="body1"
//                       sx={{
//                         fontFamily: FontFamily.NunitoRegular,
//                         color: Colors.grey,
//                         transition: "0.3s ease-in-out",
//                         "&:hover": { color: Colors.primary },
//                       }}
//                     >
//                       (+971) 6 510 2000
//                     </Typography>
//                   </Box>
                 
//                   <Box sx={{ display: "flex" }}>
//                     <LocationOnOutlined
//                       sx={{ fontSize: "28px", mr: 1.5, color: Colors.primary }}
//                     />
//                     <Typography
//                       variant="body1"
//                       sx={{
//                         fontFamily: FontFamily.NunitoRegular,
//                         color: Colors.grey,
//                       }}
//                     >
//                       Al Ruqa Al Hamra - Near Souk Al Haraj Sharjah | United
//                       Arab Emirates
//                     </Typography>
//                   </Box>
                 
//                   <Box sx={{ display: "flex" }}>
//                     <AccessTime
//                       sx={{ fontSize: "28px", mr: 1.5, color: Colors.primary }}
//                     />
//                     <Typography
//                       variant="body1"
//                       sx={{
//                         fontFamily: FontFamily.NunitoRegular,
//                         color: Colors.grey,
//                       }}
//                     >
//                       Monday to Saturday 09:00AM to 07:00 PM.
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Box>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Box sx={{ mt: 3 }}>
//                 {/* <Typography variant="h5" sx={{ color: Colors.white }}>
//                   Subscribe
//                 </Typography>
//                 <Box className={"heading-divider"} sx={{ mt: 2.5, mb: 3 }} /> */}
//                 {/* <Box
//                   component="form"
//                   onSubmit={handleSubmit(newsLetter)}
//                   sx={{ my: 1.5 }}
//                 >
//                   <FormControl
//                     variant="standard"
//                     fullWidth
//                     sx={{ my: 1.3, ".MuiFormHelperText-root": { ml: 0 } }}
//                   >
//                     <CustomTextField
//                       type={"email"}
//                       placeholder={"Email Address"}
//                       InputProps={{
//                         endAdornment: (
//                           <InputAdornment position="end">
//                             <IconButton type="submit" edge="end">
//                               {loading ? (
//                                 <CircularProgress
//                                   size={20}
//                                   sx={{ color: Colors.white }}
//                                 />
//                               ) : (
//                                 <SendOutlined
//                                   color="primary"
//                                   sx={{ transform: "rotate(-38deg)" }}
//                                 />
//                               )}
//                             </IconButton>
//                           </InputAdornment>
//                         ),
//                       }}
//                       error={errors?.email?.message}
//                       {...register("email", {
//                         required: "Please enter a your email address.",
//                         pattern: {
//                           value: emailRegex,
//                           message: "Please enter a valid email address.",
//                         },
//                       })}
//                     />
//                     {errors?.email?.message && (
//                       <Typography
//                         sx={{
//                           color: Colors.danger,
//                           fontSize: 12,
//                           textAlign: "left",
//                         }}
//                       >
//                         {errors?.email?.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Box> */}
//                 <Typography variant="h5" sx={{ color: Colors.white, mb: 2 }}>
//                   Get The App
//                 </Typography>
//                 <Link
//                   to="https://play.google.com/store/apps/details?id=com.galaxyshipping.app"
//                   aria-label="play store"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <Box
//                     component="img"
//                     loading="lazy"
//                     src={Images.googlePlay}
//                     alt={"play store"}
//                     sx={{ width: "130px", mr: 1 }}
//                   />
//                 </Link>
//                 <Link
//                   to="https://apps.apple.com/pk/app/galaxy-shipping/id6747322251"
//                   aria-label="app store"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <Box
//                     component="img"
//                     loading="lazy"
//                     src={Images.appStore}
//                     alt={"app store"}
//                     sx={{ width: "130px" }}
//                   />
//                 </Link>
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </CardMedia>

//       {/* ========== Footer BottomBar ========== */}
//       <Box
//         sx={{ bgcolor: Colors.footerBg, p: "25px 8px", textAlign: "center" }}
//       >
//         <Typography
//           variant="body1"
//           sx={{ color: Colors.grey, fontFamily: FontFamily.NunitoRegular }}
//         >
//           © Copyright {moment().format("YYYY")}. All rights reserved.
//           <Typography
//             component={"a"}
//             variant="body1"
//             className={classes.copyRight}
//           >
//             &nbsp;Galaxy World Wide Shipping
//           </Typography>
//         </Typography>
//       </Box>
//     </Fragment>
//   );
// }

// export default Footer;
import React, { Fragment, useState } from "react";
import {
  Box,
  CardMedia,
  Container,
  Typography,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import {
  EmailOutlined,
  FacebookOutlined,
  Instagram,
  LinkedIn,
  LocationOnOutlined,
  WhatsApp,
  X,
  YouTube,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import Colors from "assets/Style/Colors";
import { FontFamily, Images } from "assets";
import { ErrorToaster } from "components/Toaster";
import { AccessTime } from "@mui/icons-material";
import CarMovingLeftToRight from "pages/Website/Home/shared/CarAnimation";
import i18nInstance from "../../../i18n/i18n";
const useStyles = makeStyles({
  mailBox: {
    position: "absolute",
    top: "50%",
    right: "-35px",
    transform: "translateY(-50%) skewX(-17deg)",
    height: "58px",
    width: "60px",
    fontSize: "24px",
    color: Colors.white,
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    backgroundColor: Colors.primary,
  },
  list: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    cursor: "pointer",
    transition: "0.3s ease-in-out",
    "&:hover .MuiSvgIcon-root, &:hover .MuiTypography-root": {
      color: Colors.primary,
      transition: "0.3s ease-in-out",
    },
  },
  copyRight: {
    fontFamily: `${FontFamily.NunitoRegular} !important`,
    color: Colors.primary,
    cursor: "pointer",
    transition: "0.3s ease-in-out",
    "&:hover": {
      color: Colors.white,
    },
  },
});

const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: Colors.white + "2b",
    },
    "&:hover fieldset": {
      borderColor: Colors.white + "2b",
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.primary,
    },
    "& input": {
      color: Colors.white,
      fontSize: "13px",
      fontWeight: 300,
      fontFamily: FontFamily.NunitoRegular,
    },
  },
});

function Footer() {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const isKurdish = i18nInstance.language === "ku";

  const iconBtn = {
    backgroundColor: "#313c44",
    width: "40px",
    height: "40px",
    transition: "0.3s ease-in-out",
  };

  const quickLinks = [
    { titleKey: "footer.quickLinks.items.home", path: "/" },
    { titleKey: "footer.quickLinks.items.services", path: "/services" },
    { titleKey: "footer.quickLinks.items.aboutUs", path: "/about" },
    { titleKey: "footer.quickLinks.items.blogs", path: "/blogs" },
    { titleKey: "footer.quickLinks.items.quote", path: "/quote" },
    { titleKey: "footer.quickLinks.items.careers", path: "/careers" },
    { titleKey: "footer.quickLinks.items.contactUs", path: "/contact" },
    { titleKey: "footer.quickLinks.items.buyACar", path: "/buycar" },
  ];

  const newsLetter = async (formData) => {
    setLoading(true);
    try {
      console.log(formData);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  return (
    <Fragment>
      <CarMovingLeftToRight/>
      {/* ========== Footer ========== */}
      <CardMedia
        sx={{
          bgcolor: Colors.footerBg,
          pt: { xs: "50px", md: "60px" },
          pb: { xs: "40px", md: "50px" },
          borderBottom: `1px solid ${Colors.white + "1f"}`,
        }}
      >
        <Container maxWidth="xl">
          <Grid container spacing={{ xs: 4, md: 5, lg: 6 }}>
            {/* Company Info Section */}
            <Grid item xs={12} md={6} lg={4}>
              <Link to="/">
                <Box
                  component="img"
                  src={Images.GalaxyLogo}
                  alt={t("footer.company.logoAlt")}
                  sx={{ height: { xs: "60px", lg: "90px" }, mb: 3 }}
                />
              </Link>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: FontFamily.NunitoRegular,
                  color: Colors.white,
                  lineHeight: 1.8,
                  mb: 4,
                   textAlign: isKurdish ? "right" : "left",
                   direction: isKurdish ? "rtl" : "ltr",
                   mr: isKurdish ? { xs: 0, md: 1 } : 0,
                    fontSize: isKurdish ? { xs: 14, md: 18 } : { xs: 12, md: 16 },
                }}
              >
                {t("footer.company.description")}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "center",
                  flexWrap: "wrap",
                  justifyContent: isKurdish ? "flex-end" : "flex-start",
                }}
              >
                <Typography
                  component={"a"}
                  href={"https://wa.me/+97165102000"}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  <IconButton
                    sx={{
                      ...iconBtn,
                      "&:hover": { bgcolor: Colors.whatsapp },
                    }}
                  >
                    <WhatsApp
                      sx={{ fontSize: "18px", color: Colors.white }}
                    />
                  </IconButton>
                </Typography>
                <Typography
                  component={"a"}
                  href={"https://www.facebook.com/GalaxyWorldWideShipping"}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  <IconButton
                    sx={{
                      ...iconBtn,
                      "&:hover": { bgcolor: Colors.facebook },
                    }}
                  >
                    <FacebookOutlined
                      sx={{ fontSize: "18px", color: Colors.white }}
                    />
                  </IconButton>
                </Typography>
                <Typography
                  component={"a"}
                  href={"https://www.instagram.com/GalaxyWorldWideshippingllc"}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  <IconButton
                    sx={{
                      ...iconBtn,
                      "&:hover": { bgcolor: Colors.instagram },
                    }}
                  >
                    <Instagram
                      sx={{ fontSize: "18px", color: Colors.white }}
                    />
                  </IconButton>
                </Typography>
                <Typography
                  component={"a"}
                  href={"https://www.linkedin.com/company/galaxyworldwideshipping"}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  <IconButton
                    sx={{
                      ...iconBtn,
                      "&:hover": { bgcolor: Colors.linkedin },
                    }}
                  >
                    <LinkedIn
                      sx={{ fontSize: "18px", color: Colors.white }}
                    />
                  </IconButton>
                </Typography>
                <Typography
                  component={"a"}
                  href={"https://twitter.com/GWWS_LLC"}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  <IconButton
                    sx={{ ...iconBtn, "&:hover": { bgcolor: Colors.black } }}
                  >
                    <X sx={{ fontSize: "18px", color: Colors.white }} />
                  </IconButton>
                </Typography>
                <Typography
                  component={"a"}
                  href={"https://www.youtube.com/channel/UC_8dvAz4l3v1jSRQdoU8wAA"}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                >
                  <IconButton
                    sx={{
                      ...iconBtn,
                      "&:hover": { bgcolor: Colors.youtube },
                    }}
                  >
                    <YouTube sx={{ fontSize: "18px", color: Colors.white }} />
                  </IconButton>
                </Typography>
              </Box>
            </Grid>

        
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <Typography 
                variant="h5" 
                sx={{ 
                  color: Colors.white, 
                  mb: { xs: 3, md: 4 },
                  fontSize: { xs: "1.25rem", md: "1.5rem" }
                }}
              >
                {t("footer.quickLinks.title")}
              </Typography>
            <Box
  sx={{
    display: "grid",
    gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "1fr" },
    gap: 2,
  }}
>
  {quickLinks.map((item, index) => (
    <Box
      key={index}
      component={Link}
      to={item.path}
      className={classes.list}
      sx={{
        textDecoration: "none",
        width: "fit-content",
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: Colors.white,
          fontFamily: FontFamily.NunitoRegular,
           fontSize: isKurdish ? { xs: 14, md: 20 } : { xs: 12, md: 16 },
        }}
      >
        {t(item.titleKey)}
      </Typography>
    </Box>
  ))}
</Box>

            </Grid>

        
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <Typography 
                variant="h5" 
                sx={{ 
                  color: Colors.white, 
                  mb: { xs: 3, md: 4 },
                  fontSize: { xs: "1.25rem", md: "1.5rem" }
                }}
              >
                {t("footer.findUs.title")}
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                  <EmailOutlined
                    sx={{ 
                      fontSize: "24px", 
                      mr: 2, 
                      color: Colors.white,
                      mt: 0.3
                    }}
                  />
                  <Typography
                    component={"a"}
                    href={"mailto:info@galaxyshipping.com"}
                    variant="body1"
                    sx={{
                      fontFamily: FontFamily.NunitoRegular,
                      color: Colors.white,
                      transition: "0.3s ease-in-out",
                      fontSize: "15px",
                      "&:hover": { color: Colors.primary },
                    }}
                  >
                    {t("footer.findUs.email")}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                  <WhatsApp
                    sx={{ 
                      fontSize: "24px", 
                      mr: 2, 
                      color: Colors.white,
                      mt: 0.3
                    }}
                  />
                  <Typography
                    component={"a"}
                    href={"https://wa.me/+97165102000"}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                    variant="body1"
                    sx={{
                      fontFamily: FontFamily.NunitoRegular,
                      color: Colors.white,
                      transition: "0.3s ease-in-out",
                      fontSize: "15px",
                      "&:hover": { color: Colors.primary },
                    }}
                  >
                    {t("footer.findUs.phone")}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                  <LocationOnOutlined
                    sx={{ 
                      fontSize: "24px", 
                      mr: 2, 
                      color: Colors.white,
                      mt: 0.3,
                      flexShrink: 0
                    }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontFamily: FontFamily.NunitoRegular,
                      color: Colors.white,
                      fontSize: "15px",
                      lineHeight: 1.6,
                    }}
                  >
                    {t("footer.findUs.address")}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                  <AccessTime
                    sx={{ 
                      fontSize: "24px", 
                      mr: 2, 
                      color: Colors.white,
                      mt: 0.3,
                      flexShrink: 0
                    }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontFamily: FontFamily.NunitoRegular,
                      color: Colors.white,
                      fontSize: "15px",
                      lineHeight: 1.6,
                    }}
                  >
                    {t("footer.findUs.workingHours.line1")}<br />{t("footer.findUs.workingHours.line2")}
                  </Typography>
                </Box>
              </Box>
            </Grid>

        
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <Typography 
                variant="h5" 
                sx={{ 
                  color: Colors.white, 
                  mb: { xs: 3, md: 4 },
                  fontSize: { xs: "1.25rem", md: "1.5rem" }
                }}
              >
                {t("footer.getApp.title")}
              </Typography>
           <Box
  sx={{
    display: "grid",
    gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "1fr" },
    gap: 2.5,
    alignItems: "center",
  }}
>
  <Link
    to="https://play.google.com/store/apps/details?id=com.galaxyshipping.app"
    aria-label={t("footer.getApp.playStoreAriaLabel")}
    target="_blank"
    rel="noopener noreferrer"
  >
    <Box
      component="img"
      loading="lazy"
      src={Images.googlePlay}
      alt={t("footer.getApp.playStoreAlt")}
      sx={{
        width: "140px",
        mx: "auto", // mobile pe nicely centered
        transition: "0.3s ease-in-out",
        "&:hover": {
          transform: "scale(1.05)",
        },
      }}
    />
  </Link>

  <Link
    to="https://apps.apple.com/pk/app/galaxy-shipping/id6747322251"
    aria-label={t("footer.getApp.appStoreAriaLabel")}
    target="_blank"
    rel="noopener noreferrer"
  >
    <Box
      component="img"
      loading="lazy"
      src={Images.appStore}
      alt={t("footer.getApp.appStoreAlt")}
      sx={{
        width: "140px",
        mx: "auto",
        transition: "0.3s ease-in-out",
        "&:hover": {
          transform: "scale(1.05)",
        },
      }}
    />
  </Link>
</Box>

            </Grid>
          </Grid>
        </Container>
      </CardMedia>

      {/* ========== Footer BottomBar ========== */}
      <Box
        sx={{ 
          bgcolor: Colors.footerBg, 
          py: 3, 
          px: 2,
          textAlign: "center" 
        }}
      >
        <Typography
          variant="body1"
          sx={{ 
            color: Colors.white, 
            fontFamily: FontFamily.NunitoRegular,
            fontSize: "15px"
          }}
        >
          {t("footer.bottomBar.copyrightPrefix")} {moment().format("YYYY")}. {t("footer.bottomBar.rightsReserved")}
          <Typography
            component={"a"}
            variant="body1"
            className={classes.copyRight}
          >
            &nbsp;{t("footer.bottomBar.brandName")}
          </Typography>
        </Typography>
      </Box>
    </Fragment>
  );
}

export default Footer;